import axios from "axios";
import url from "../config/urlServiceConfig";

const groupAPI = {
  getAll: () => axios.get(url.group),
  getById: id => axios.get(`${url.group}/${id}`),
  create: body => axios.post(url.group, body),
  update: body => axios.put(url.group, body),
  delete: id => axios.delete(`${url.group}/${id}`)
};

export default groupAPI;
